import Swiper, { Navigation, Pagination } from 'swiper';

document.addEventListener('readystatechange', () => {
    if (document.readyState !== 'complete') return;

    const swiper = new Swiper('.diu-logo-slider-container', {
        modules: [Navigation, Pagination],
        slidesPerView: 5,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    enabled: true,
                },
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    enabled: true,
                },
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 20,
                navigation: {
                    enabled: true,
                },
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 30,
                navigation: {
                    enabled: true,
                },
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
